import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Nav } from "@/components/sections/Nav";
import { Hero } from "@/components/sections/Hero";
import { About } from "@/components/sections/About";
import { EditorialMarquee } from "@/components/sections/EditorialMarquee";
import { Problem } from "@/components/sections/Problem";
import { Method } from "@/components/sections/Method";
import { WhatYouGet } from "@/components/sections/WhatYouGet";
import { WhoThisIsFor } from "@/components/sections/WhoThisIsFor";
import { Testimonials } from "@/components/sections/Testimonials";
import { ClosingCTA } from "@/components/sections/ClosingCTA";
import { Footer } from "@/components/sections/Footer";
import ApplyPage from "@/pages/ApplyPage";

function Landing() {
  return (
    <>
      <Nav />
      <main>
        <Hero />
        <About />
        <EditorialMarquee />
        <Problem />
        <Method />
        <WhatYouGet />
        <WhoThisIsFor />
        <Testimonials />
        <ClosingCTA />
      </main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App relative">
      <div className="grain-overlay" aria-hidden="true" />
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "rgba(10,10,10,0.9)",
            border: "1px solid rgba(255,255,255,0.1)",
            backdropFilter: "blur(16px)",
            color: "#fafafa",
            fontFamily: "Manrope, sans-serif",
          },
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/apply" element={<ApplyPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
